import script from "./PackagesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PackagesModal.vue?vue&type=script&setup=true&lang=js"

import "./PackagesModal.vue?vue&type=style&index=0&id=5baeb0ad&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5baeb0ad"]])

export default __exports__